import React, { useEffect } from "react";
import "./Home.css";
import MainLayout from "components/layout/main-layout/MainLayout.js";
import MessageSnackBar from "components/widgets/message-snackbar/MessageSnackBar";
import { useAdvancedValidation } from "hooks/useAdvancedValidation";
import { ROUTES_CONSTANTS } from "routes/route-constants";
import { useHistory } from "react-router-dom";
import AccountHolderHome from "./account-holder-home/AccountHolderHome";
import { useDispatch, useSelector } from "react-redux";
import { getAccountOwnerDetails, getEsignHistoryList } from "redux/UserDetails/actions";
import {
  getMedicalAlertUsers,
  setSelectedMedicalUser,
} from "redux/MedicalAlertUsers/actions";
import { getStaticUrls } from "redux/Common/action";
import { RightFill } from "assets/SVGs/SVGs";
import { sub_profile } from "assets/images/images";

const Home = () => {
  const { snackbarState, dismissSnackbar, onApiResponse } =
    useAdvancedValidation({});
  const userData = useSelector((store) => store?.auth?.userData);
  const medicalAlertUserList = useSelector(
    (store) => store?.medicalAlertUsers?.medicalAlertUserList
  );
  const isMedicalUserLoading = useSelector(
    (store) => store?.medicalAlertUsers?.loading
  );
  const { medicalUserTimezone } = useSelector(
    (store) => store?.common
  );
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (!userData?.isGuestUser) {
      getAccountOwnerDetails(dispatch, history);
      getEsignHistoryList(dispatch, history);
    }
    getMedicalUsers();
  }, []);

  const getMedicalUsers = () => {
    setTimeout(() => {
      const params = {
        dispatch,
        onApiResponse,
        userType: userData?.isGuestUser ? "guestuser" : "accountowner",
        history,
      };
      getMedicalAlertUsers(params);
      getStaticUrls(params);
    }, 500);
  };

  const onSubscriberDetail = async (item) => {
    setSelectedMedicalUser(dispatch, item);
    const timezone =
      medicalUserTimezone?.length > 0
        ? await medicalUserTimezone?.find(
          (data) => data?.medicalAlertUserId === item?.medical_alert_user_id
        )
        : null;

    setSelectedMedicalUser(dispatch, { ...item, ...timezone });
    history.push(ROUTES_CONSTANTS?.subscriberProfile, {
      item: item,
    });
  };

  return (
    <MainLayout
      text={""}
      isBackHide={false}
      isSemiHeader={false}
      fullWidthScreen={true}
      isHomeHeader={false}
      isLoading={isMedicalUserLoading}
      white={true}
    >
      {snackbarState?.show && (
        <div className="snackbar_sticky">
          <MessageSnackBar
            message={snackbarState?.message}
            isVisible={true}
            type={snackbarState?.type}
            autoHideDuration={snackbarState?.autoHideDuration}
            onDismiss={dismissSnackbar}
          />
        </div>
      )}
      <div className="home_main_container">
        <AccountHolderHome />
        <div className="home_subscriber_section">
          <div className="home_subscriber_header">
            <h2 className="home_subscriber_title">Subscriber Profiles</h2>
          </div>
          <div className="home_subscriber_list">
            {medicalAlertUserList?.map((item, index) => {
              return (
                <div key={`medicalusers${index}`} className="home_subscriber_card" onClick={() => onSubscriberDetail(item)}>
                  <div className="home_subscriber_profile_image">
                    <img src={sub_profile} alt="Profile" className="home_profile_image" />
                  </div>
                  <div className="home_subscriber_content">
                    <h3 className="home_subscriber_name">{item?.firstname + " " + item?.lastname}</h3>
                    <p className="home_subscriber_status">{item?.ag_timezone}</p>
                  </div>
                  <div className="home_subscriber_arrow">
                    <RightFill color="#DB4E3B" width="32" height="32" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default Home;
